// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_EcO","cls2":"DebugPage-cls2_FJ6 DebugPage-cls1_EcO"};